import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import TextFieldEditor from '../text-field-editor/TextFieldEditor.jsx';

import s from './PoiSheet.module.scss';

const PoiName = ({ isDisabled, onUpdatePoiField, poiStatus, poi, isNameEmpty }) => (
    <div className={s.nameEditor}>
        <div className={s.inputContainer}>
            <TextFieldEditor
                label="Poi name"
                value={poi.name}
                onChange={newName => onUpdatePoiField('name', newName)}
                big
                disabled={isDisabled}
                inputBoxClass={classNames({ [s.emptyName]: isNameEmpty })}
            />
            <span data-testid="poi-status" className={classNames(s.status, s[poiStatus])}>
                {poiStatus === 'current' ? 'CURRENT' : poiStatus === 'archived' ? 'ARCHIVED' : ''}
            </span>
        </div>
    </div>
);

PoiName.propTypes = {
    isDisabled: PropTypes.bool,
    isNameEmpty: PropTypes.bool.isRequired,
    onUpdatePoiField: PropTypes.func,
    poiStatus: PropTypes.oneOf(['current', 'archived', '']),
    poi: PropTypes.object,
};

PoiName.defaultProps = {
    isDisabled: true,
    onUpdatePoiField: () => {},
    poiStatus: '',
    poi: {},
};

export default PoiName;
